// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"social-share-m__horizontal__a4ItY","share":"social-share-m__share__2Wkzy","open":"social-share-m__open__2LbQc"};